import React, { useState } from 'react';
import PropTypes from 'prop-types';

const CacToggleLabel = props => {
  const { label, check, id, chartUpdate } = props;
  const [checked, setChecked] = useState(check);
  const toggleChecked = () => {
    chartUpdate(!checked);
    setChecked(!checked);
  };

  return (
    <div className="toggleLabel cacInfoboxLabel" data-test="CacToggleLabel">
      <span className="toggleHeading">{label}</span>
      <span className="radio-toggle">
        <label className="rb-switcher blue" htmlFor={id}>
          <input
            data-test="toggleButton"
            type="radio"
            name={`cacTL_${id}`}
            id={id}
            checked={checked}
            onClick={toggleChecked}
          />{' '}
          <i />
        </label>
      </span>
    </div >
  );
};

CacToggleLabel.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  check: PropTypes.bool,
  chartUpdate: PropTypes.func,
};

export default CacToggleLabel;
